export const ConsumerNameViewUat = {
  header: 'workflow.consumerName.header',
  paragraph: 'workflow.consumerName.paragraph'
}
